<div class="comments">
  <div class="wrap">

    <div *ngIf="comments.items.length">
      <div class="item" *ngFor="let comment of comments.items; trackBy: trackCommentByFn">
        <app-comment
          [content]="content"
          [comment]="comment"
          (removed)="onRemoved()"
          (commented)="onCommented()"></app-comment>
        <hr class="separator">
      </div>

      <div class="next"
           *ngIf="comments.pagination.page < comments.pagination.totalPages"
           (click)="loadComments(true)">
        {{ 'comments.next-comments' | customLocale }}
      </div>
    </div>

    <div *ngIf="isCommentsOpen">
      <app-comment-form
        [content]="content"
        (commented)="onCommented()"></app-comment-form>
    </div>
    <!--
    <div *ngIf="!isCommentsOpen">Комментарии закрыты</div>
    -->
  </div>
</div>
